import s from '../styles/dashboard.module.css';

const Disclaimer = () => (
  <footer className={s.footer}>
    <p className={s.footerText}>
      <strong>Indicative briefing.</strong> Generated for educational planning
      purposes only. Not personal financial, credit or tax advice. All lender
      rates, policies and lending criteria must be verified against live lender
      data. ODIN holds ACL 520379 and is registered with the Tax Practitioners
      Board (Licence 26295891). All figures in AUD unless stated.
    </p>
  </footer>
);

export default Disclaimer;
